import type { LinkInternal } from '@backmarket/http-api'
import type { Location } from '@ds/types/Location'

/**
 * Validates if a link is a valid product link (variant or master product page).
 */
export function isValidProductLink(
  link: LinkInternal | Location | string | null | undefined,
): boolean {
  if (!link) return false

  if (typeof link === 'string') return link.length > 0

  const params = 'params' in link ? link.params : undefined
  const name = 'name' in link ? link.name : undefined

  return !!name && !!(params?.slugV2 || params?.slug)
}
